import type { LoadingStateType } from '@/shared/config';

import type { FullHeadMprSlicesBranch } from '../config';

export const resolveFullHeadMprSlicesBranch = ({
  groupCount,
  hasSavedViews = false,
  hasSeries = false,
  hasToothInput = true,
  isEnabled,
  isUnavailable,
  loading,
  savedViewsLoading = 'idle',
}: {
  groupCount: number;
  isEnabled: boolean;
  isUnavailable: boolean;
  loading: LoadingStateType;
  hasSavedViews?: boolean;
  hasSeries?: boolean;
  hasToothInput?: boolean;
  savedViewsLoading?: LoadingStateType;
}): FullHeadMprSlicesBranch => {
  if (!isEnabled) {
    return 'server';
  }

  if (isUnavailable) {
    return 'collapsed';
  }

  const contentLoading =
    loading === 'pending' && hasSeries
      ? 'succeeded'
      : hasSavedViews && (!hasToothInput || loading === 'succeeded')
        ? savedViewsLoading
        : loading;

  if (contentLoading === 'failed') {
    return 'failed';
  }

  if (contentLoading !== 'succeeded' && !hasSeries) {
    return 'skeleton';
  }

  return groupCount > 0 ? 'tiles' : 'collapsed';
};
